/*
// KJR 2014-08-22
// Global JS included on every page.  Add all your common script inits here.
*/

//$(document).ready(function() {
//$(function() { // Shorthand for $( document ).ready()
window.addEventListener('DOMContentLoaded', function() {
	// executes when HTML-Document is loaded and DOM is ready

	//fix for Windows Phone 8
	if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
		var msViewportStyle = document.createElement('style');
		msViewportStyle.appendChild(
			document.createTextNode(
				'@-ms-viewport{width:auto!important}'
			)
		);
		document.querySelector('head').appendChild(msViewportStyle);
	}

	//track phone number taps & clicks
	$('.tel').on('click', function(e){
		e.preventDefault();
		trackEvent('Mobile', 'Click to Call', $(this).data('tel'));
		window.location = 'tel:'+$(this).data('tel');
	});

	//decrypt encrypted mailto links
	$('.mailto').each(function() {
		var strEncrypted = $(this).html();
		var parts = strEncrypted.split("|");
		var email = rot13(decodeBase64(parts[0]));
		var display = rot13(decodeBase64(parts[1]));
		var html = '<a class="email" href="mailto:'+email+'">'+display+'</a>';
		$(this).html(html);
	});

	//set noopener for all external links
	$('a[target="_blank"]').each(function() {
		var rel = '';
		if ( $(this).attr("rel") ) {
			rel = $(this).attr("rel");
			rel = rel.replace('noopener', '').trim();
			if (rel.length > 0) {
				rel += ' ';
			}
		}
		$(this).attr('rel', rel+'noopener');
	});

	//initBackgroundResize();
	initLayout() ;
//}); //End document.ready
}, true); //End document.ready

//window.onload = function() {
window.addEventListener('load', function() {
	// executes when complete page is fully loaded, including all frames, objects and images
//}; //End window.onload
}, true); //End window.onload


//Google Analytics Event Tracking
//https://developers.google.com/analytics/devguides/collection/analyticsjs/events
function trackEvent(category, action, label) {
	//EXAMPLES:
	//ga('send', 'event', 'Videos', 'Play', 'Gone With the Wind']);
	//ga('send', 'event', 'Videos', 'Downloaded', 'Gone With the Wind']);
	//ga('send', 'event', 'Downloads', 'PDF', 'Expense Report']);
	//ga('send', 'event', 'datasheet-download', 'click', 'http://www.myurl.com');
	if (typeof ga !== 'undefined') {
		//ga('send', 'event', category, action, label);
		gtag('event', action, {
			// Event parameters
			'event_category': category,
			'event_label': label
		});
	} else {
		console.log('Simulating GA event tracking: category = "'+category+'", action = "'+action+'", label = "'+label+'"');
	}
}

function addScrollToOnClick(clickedElm, targetElm, animationDuration) {
	$(clickedElm).click(function(event) {
		//console.log('addScrollToOnClick: '+targetElm);
		$('html, body').animate({scrollTop: $(targetElm).offset().top}, animationDuration);
		return true;
	});
}

function getScrollbarWidth() {
	var outer = document.createElement("div");
	outer.style.visibility = "hidden";
	outer.style.width = "100px";
	document.body.appendChild(outer);

	var widthNoScroll = outer.offsetWidth;
	// force scrollbars
	outer.style.overflow = "scroll";

	// add innerdiv
	var inner = document.createElement("div");
	inner.style.width = "100%";
	outer.appendChild(inner);

	var widthWithScroll = inner.offsetWidth;

	// remove divs
	outer.parentNode.removeChild(outer);

	return widthNoScroll - widthWithScroll;
}

/*
 * jQuery getCSS Plugin
 * Copyright 2013, intesso
 * MIT license.
 *
 * cross browser function to dynamically load an external css file.
 * see: [github page](http://intesso.github.com/jquery-getCSS/)
 *
 */

(function() {
	/*
		arguments: attributes
		attributes can be a string: then it goes directly inside the href attribute.
		e.g.: $.getCSS("fresh.css")
		attributes can also be an objcet.
		e.g.: $.getCSS({href:"cool.css", media:"print"})
		or:	$.getCSS({href:"/styles/forest.css", media:"screen"})
	*/
	var getCSS = function(attributes) {
			// setting default attributes
			if(typeof attributes === "string") {
				var href = attributes;
				attributes = {
					href: href
				};
			}
			if(!attributes.rel) {
				attributes.rel = "stylesheet";
			}
			// appending the stylesheet
			// no jQuery stuff here, just plain dom manipulations
			var styleSheet = document.createElement("link");
			for(var key in attributes) {
				styleSheet.setAttribute(key, attributes[key]);
			}
			var head = document.getElementsByTagName("head")[0];
			head.appendChild(styleSheet);
		};

	if(typeof jQuery === "undefined") {
		window.getCSS = getCSS;
	} else {
		jQuery.getCSS = getCSS;
	}

})();

// responsive layout handling
function initLayout() {
	var winPhone = (/MSIE 10.*Touch/.test(navigator.userAgent)) ;
	var isTouchDevice = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

	// handle layout resize
	ResponsiveHelper.addRange({
		'..599': {
			on: function() {
				jQuery('.add-nav ul').miniAccordion({
					activeClass: 'active',
					opener: '> a',
					slide: 'ul',
					animSpeed: 300
				});
			},
			off: function() {
				jQuery('.add-nav ul').miniAccordion('destroy');
			}
		},
		'768..': {
		}
	});
}

// stretch background to fill blocks
function initBackgroundResize() {
	jQuery('.banner').each(function() {
		ImageStretcher.add({
			container: this,
			image: 'img'
		});
	});
}

/*
 * Image Stretch module
 */
var ImageStretcher = {
	getDimensions: function(data) {
		// calculate element coords to fit in mask
		var ratio = data.imageRatio || (data.imageWidth / data.imageHeight),
			slideWidth = data.maskWidth,
			slideHeight = slideWidth / ratio;

		if(slideHeight < data.maskHeight) {
			slideHeight = data.maskHeight;
			slideWidth = slideHeight * ratio;
		}
		return {
			width: slideWidth,
			height: slideHeight,
			top: (data.maskHeight - slideHeight) / 2,
			left: (data.maskWidth - slideWidth) / 2
		};
	},
	getRatio: function(image) {
		if(image.prop('naturalWidth')) {
			return image.prop('naturalWidth') / image.prop('naturalHeight');
		} else {
			var img = new Image();
			img.src = image.prop('src');
			return img.width / img.height;
		}
	},
	imageLoaded: function(image, callback) {
		var self = this;
		var loadHandler = function() {
			callback.call(self);
		};
		if(image.prop('complete')) {
			loadHandler();
		} else {
			image.one('load', loadHandler);
		}
	},
	resizeHandler: function() {
		var self = this;
		jQuery.each(this.imgList, function(index, item) {
			if(item.image.prop('complete')) {
				self.resizeImage(item.image, item.container);
			}
		});
	},
	resizeImage: function(image, container) {
		this.imageLoaded(image, function() {
			var styles = this.getDimensions({
				imageRatio: this.getRatio(image),
				maskWidth: container.width(),
				maskHeight: container.height()
			});
			image.css({
				width: styles.width,
				height: styles.height,
				marginTop: styles.top,
				marginLeft: styles.left
			});
		});
	},
	add: function(options) {
		var container = jQuery(options.container ? options.container : window),
			image = typeof options.image === 'string' ? container.find(options.image) : jQuery(options.image);

		// resize image
		this.resizeImage(image, container);

		// add resize handler once if needed
		if(!this.win) {
			this.resizeHandler = jQuery.proxy(this.resizeHandler, this);
			this.imgList = [];
			this.win = jQuery(window);
			this.win.on('resize orientationchange', this.resizeHandler);
		}

		// store item in collection
		this.imgList.push({
			container: container,
			image: image
		});
	}
};

/*
 * miniAccordion
 */
;(function($) {
	function MiniAccordion(options) {
		this.options = {
			activeClass: 'active',
			opener: '> a',
			slide: '> ul',
			animSpeed: 300
		}
		$.extend(this.options, options);
		this.init();
	}
	MiniAccordion.prototype = {
		init: function() {
			this.findElements();
			this.addEvents();
			this.makeCallback('onInit', this);
		},
		findElements: function() {
			this.accordion = $(this.options.holder);
			this.items = this.accordion.find(':has(' + this.options.slide + ')');
		},
		addEvents: function() {
			var that = this;

			that.items.each(function() {
				var item = $(this);
				var slide = item.find(that.options.slide);
				var opener = item.find(that.options.opener);

				if (item.hasClass(that.options.activeClass)) {
					slide.show();
					that.activeItem = item;
					that.defActive = item;
				} else {
					slide.hide();
				}

				opener.bind('click.acc', function(e) {
					e.preventDefault();
					that.toggleSlide(item);
				});
			});
		},
		toggleSlide: function(item) {
			var that = this;

			if (item.is(that.activeItem)) {
				item.find(that.options.slide).stop().slideUp(that.options.animSpeed)
				item.removeClass(that.options.activeClass);
				that.activeItem = null;
			} else {
				if (that.activeItem) {
					that.activeItem.find(that.options.slide).stop().slideUp(that.options.animSpeed)
					that.activeItem.removeClass(that.options.activeClass);
				}
				item.find(that.options.slide).stop().slideDown(that.options.animSpeed)
				item.addClass(that.options.activeClass);
				that.activeItem = item;
			}
		},
		destroy: function() {
			var that = this;

			that.destroyed = true;
			that.items.each(function() {
				var item = $(this);
				var slide = item.find(that.options.slide);
				var opener = item.find(that.options.opener);

				item.toggleClass(that.options.activeClass, item.is(that.defActive))
				slide.css('display', '');

				opener.unbind('click.acc');
			});
			that.accordion.removeData('MiniAccordion');
		},
		makeCallback: function(name) {
			if(typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		}
	}

	$.fn.miniAccordion = function(options) {
		var args = Array.prototype.slice.apply(arguments);
		return this.each(function(){
			var instance = $.data(this, 'MiniAccordion');
			var methodName = args[0];
			if (instance) {
				if (typeof methodName === 'string') {
					instance[methodName].apply(instance, args.slice(1));
				}
			} else if (typeof methodName !== 'string') {
				$(this).data('MiniAccordion', new MiniAccordion($.extend(options, {holder: this})));
			}
		});
	}
}(jQuery));

/*
 * Responsive Layout helper
 */
ResponsiveHelper = (function($){
	// init variables
	var handlers = [];
	var win = $(window), prevWinWidth;
	var scrollBarWidth = 0;

	// prepare resize handler
	function resizeHandler() {
		var winWidth = win.width() + scrollBarWidth;
		if(winWidth !== prevWinWidth) {
			prevWinWidth = winWidth;

			// loop through range groups
			$.each(handlers, function(index, rangeObject){
				// disable current active area if needed
				$.each(rangeObject.data, function(property, item) {
					if((winWidth < item.range[0] || winWidth > item.range[1]) && item.currentActive) {
						item.currentActive = false;
						if(typeof item.disableCallback === 'function') {
							item.disableCallback();
						}
					}
				});

				// enable areas that match current width
				$.each(rangeObject.data, function(property, item) {
					if(winWidth >= item.range[0] && winWidth <= item.range[1] && !item.currentActive) {
						// make callback
						item.currentActive = true;
						if(typeof item.enableCallback === 'function') {
							item.enableCallback();
						}
					}
				});
			});
		}
	}
	win.bind('load', function(){
		//if(($.browser.mozilla || $.browser.opera || $.browser.msie) && window.addEventListener) {
		if(window.addEventListener) {
			scrollBarWidth = window.innerWidth - $('body').width();
			resizeHandler();
		}
		win.bind('resize orientationchange', resizeHandler);
	});

	// range parser
	function parseRange(rangeStr) {
		var rangeData = rangeStr.split('..');
		var x1 = parseInt(rangeData[0], 10) || -Infinity;
		var x2 = parseInt(rangeData[1], 10) || Infinity;
		return [x1, x2].sort(function(a, b){
			return a - b;
		});
	}

	// export public functions
	return {
		addRange: function(ranges) {
			// parse data and add items to collection
			var result = {data:{}};
			$.each(ranges, function(property, data){
				result.data[property] = {
					range: parseRange(property),
					enableCallback: data.on,
					disableCallback: data.off
				};
			});
			handlers.push(result);

			// call resizeHandler to recalculate all events
			prevWinWidth = null;
			resizeHandler();
		}
	};
}(jQuery));

